import { FC, ReactNode } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { ChevronDownIcon } from './icons';

interface Props {
  question: string;
  children: ReactNode;
}

const FaqAccordion: FC<Props> = ({ question, children }) => (
  <Accordion
    disableGutters
    elevation={0}
    TransitionProps={{ unmountOnExit: true }}
    sx={theme => {
      const radius = theme.shape.borderRadius * 3;

      return {
        bgcolor: 'common.white',
        border: 1,
        borderColor: 'staticPages.border.card',
        borderRadius: `${radius}px`,
        // MuiAccordion resets first/last radii to theme.shape.borderRadius
        '&:first-of-type': {
          borderTopLeftRadius: `${radius}px`,
          borderTopRightRadius: `${radius}px`,
        },
        '&:last-of-type': {
          borderBottomLeftRadius: `${radius}px`,
          borderBottomRightRadius: `${radius}px`,
        },
        mb: 1.5,
        boxShadow: theme.palette.staticPages.shadow.sm,
        '&:before': { display: 'none' },
      };
    }}
  >
    <AccordionSummary
      expandIcon={<ChevronDownIcon size={20} />}
      sx={{
        typography: 'body1',
        px: 3,
        fontWeight: 600,
        color: 'staticPages.navy',
        textAlign: 'left',
        '& .MuiAccordionSummary-content': { my: 2.5, pr: 2 },
        '& .MuiAccordionSummary-expandIconWrapper': {
          color: 'staticPages.orange',
        },
      }}
    >
      {question}
    </AccordionSummary>
    <AccordionDetails
      sx={{
        typography: 'body2',
        pt: 0,
        px: 3,
        pb: 3,
        color: 'staticPages.text.secondary',
        lineHeight: 1.7,
      }}
    >
      {children}
    </AccordionDetails>
  </Accordion>
);

export default FaqAccordion;
